'use strict';

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmartCheckbox = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _rcCheckbox = require('rc-checkbox');

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _themr = require('react-css-themr/lib/components/themr');

var _themr2 = _interopRequireDefault(_themr);

var _identifiers = require('../../../identifiers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SmartCheckbox = function (_React$Component) {
  _inherits(SmartCheckbox, _React$Component);

  function SmartCheckbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SmartCheckbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartCheckbox.__proto__ || Object.getPrototypeOf(SmartCheckbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleTextClick = function () {
      var _this$props = _this.props,
          checked = _this$props.checked,
          onChange = _this$props.onChange;
      onChange(!checked);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SmartCheckbox, [{
    key: 'render',
    value: function render() {
      var _cn;

      var _props = this.props,
          theme = _props.theme,
          name = _props.name,
          defaultChecked = _props.defaultChecked,
          checked = _props.checked,
          onChange = _props.onChange,
          value = _props.value,
          disabled = _props.disabled,
          position = _props.position,
          noInteraction = _props.noInteraction,
          valid = _props.valid,
          textComponent = _props.textComponent,
          style = _props.style;
      var wrapperClasses = (0, _classnames2['default'])(theme.wrapper, (_cn = {}, _defineProperty(_cn, theme.start, position === 'start'), _defineProperty(_cn, theme.end, position === 'end'), _defineProperty(_cn, theme.lonely, position === 'lonely'), _defineProperty(_cn, theme.invalid, valid === false), _cn));
      return _react2['default'].createElement('div', {
        className: wrapperClasses,
        style: style
      }, _react2['default'].createElement(_rcCheckbox2['default'], {
        name: name,
        defaultChecked: defaultChecked,
        checked: checked,
        onChange: noInteraction ? undefined : onChange,
        value: value,
        disabled: disabled
      }), _react2['default'].createElement('div', {
        className: theme.text,
        onClick: noInteraction ? undefined : this.handleTextClick
      }, textComponent));
    }
  }]);

  return SmartCheckbox;
}(_react2['default'].Component);

SmartCheckbox.defaultProps = {
  textComponent: null
};
SmartCheckbox.propTypes = {
  theme: _propTypes2['default'].object,
  style: _propTypes2['default'].object,
  name: _propTypes2['default'].string,
  defaultChecked: _propTypes2['default'].bool,
  checked: _propTypes2['default'].bool,
  onChange: _propTypes2['default'].func,
  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
  disabled: _propTypes2['default'].bool,
  position: _propTypes2['default'].oneOf(['default', 'start', 'end', 'lonely']),
  noInteraction: _propTypes2['default'].bool,
  valid: _propTypes2['default'].bool,
  textComponent: _propTypes2['default'].any
};
var themed = (0, _themr2['default'])(_identifiers.SMART_FORM_CHECKBOX)(SmartCheckbox);
exports.SmartCheckbox = SmartCheckbox;
exports['default'] = themed;